import ApiResponseV1 from './v1'
import ApiResponseV2 from './v2'

export default ApiResponseV1
export {
  ApiResponseV1,
  ApiResponseV2,
}
